var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { ParnassysSearch } from '@/models/ParnassysSearch';
import { User } from '@/models/User';
import ErrorHandler from '@/support/ErrorHandler';
import { cloneDeep } from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
let DialogParnassysLink = class DialogParnassysLink extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = 1;
        this.isFormValid = false;
        this.isLoading = false;
        this.isUpdatingUser = false;
        this.selectedUser = null;
        this.userClone = new User();
        this.parnassysSearchResults = null;
        this.isLoadingResults = false;
    }
    get hasParnassysSearchResults() {
        return !!(this.parnassysSearchResults && this.parnassysSearchResults.length);
    }
    get requiredRule() {
        return () => !!this.selectedUser || 'Selection is required';
    }
    get firstOrLastNameSelected() {
        return !!(this.userClone.first_name || this.userClone.last_name) || false;
    }
    close() {
        this.$emit('input', false);
        this.currentStep = 1;
    }
    mounted() {
        if (this.user && this.user.id) {
            this.userClone = cloneDeep(this.user);
        }
    }
    findUsers() {
        this.isLoadingResults = true;
        new ParnassysSearch()
            .create({
            user: this.userClone.id,
            first_name: this.userClone && this.userClone.first_name || '',
            middle_name: this.userClone && this.userClone.middle_name || '',
            last_name: this.userClone && this.userClone.last_name || '',
        }).then((response) => {
            this.parnassysSearchResults = response;
            this.isLoadingResults = false;
        }).catch((error) => {
            this.clear();
            ErrorHandler.network(error);
            this.isLoadingResults = false;
        });
    }
    updateParnassysUsers() {
        new User({ id: this.userClone.id })
            .update({
            parnassys_id: (this.selectedUser && this.selectedUser.id || ''),
        }).then((response) => {
            this.parnassysSearchResults = response;
            this.isUpdatingUser = false;
        }).catch((error) => {
            ErrorHandler.network(error);
            this.toStep(1);
        });
        this.isUpdatingUser = false;
        this.$emit('linked', true);
    }
    toStep(step) {
        if (step === 2) {
            this.isUpdatingUser = true;
            this.updateParnassysUsers();
        }
        if (step == 1) {
            this.clear();
        }
        this.currentStep = step;
    }
    clear() {
        this.parnassysSearchResults = [];
        this.selectedUser = null;
        this.isUpdatingUser = false;
        this.isFormValid = false;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], DialogParnassysLink.prototype, "user", void 0);
DialogParnassysLink = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
        },
    })
], DialogParnassysLink);
export default DialogParnassysLink;
